import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ThemeToggle } from "../components/ThemeToggle";

function NavButton({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink to={to}>
      {({ isActive }) => (
        <button type="button" className={isActive ? "active" : ""}>
          {children}
        </button>
      )}
    </NavLink>
  );
}

export function AppLayout() {
  const { profile, signOut } = useAuth();

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">
          <h1>nexTrak</h1>
          <p>
            {profile?.display_name || profile?.username || "User"}
            {profile?.is_admin ? " · Admin" : ""}
          </p>
        </div>
        <nav className="nav">
          <NavButton to="/applications">Applications</NavButton>
          <NavButton to="/companies">Prospective companies</NavButton>
          <NavButton to="/jobs">Jobs</NavButton>
          <NavButton to="/agent">Agent Settings</NavButton>
          {profile?.is_admin ? <NavButton to="/admin">Admin</NavButton> : null}
          <ThemeToggle />
          <button type="button" className="btn" onClick={() => void signOut()}>
            Sign out
          </button>
        </nav>
      </header>
      <Outlet />
    </div>
  );
}
